import { c as _c } from "react/compiler-runtime";
import type { ComponentProps, JSX } from 'react';
import EmailPreview from '../../email-preview';
import PhoneForm from '../../phone-form';
import type { HeaderProps } from '../types';
type PhoneFormProps = ComponentProps<typeof PhoneForm>;
type PhonePageStructureProps = {
  defaultPhone?: string;
  email?: string;
  Footer?: JSX.Element;
  Header: (props: HeaderProps) => JSX.Element;
  isLoading?: boolean;
  l10n?: PhoneFormProps['l10n'];
  onChangeEmailClick?: () => void;
  onSubmit: (phone: string) => void;
  phoneValidator: PhoneFormProps['validator'];
  texts: {
    headerTitle: string;
    headerSubtitle?: string;
    emailChangeCta?: string;
  } & PhoneFormProps['texts'];
};
const PhonePageStructure = t0 => {
  const $ = _c(27);
  const {
    defaultPhone,
    email,
    Footer,
    Header,
    isLoading,
    l10n,
    onChangeEmailClick,
    onSubmit,
    phoneValidator,
    texts
  } = t0;
  let emailChangeCta;
  let headerSubtitle;
  let headerTitle;
  let phoneTexts;
  if ($[0] !== texts) {
    ({
      headerTitle,
      headerSubtitle,
      emailChangeCta,
      ...phoneTexts
    } = texts);
    $[0] = texts;
    $[1] = emailChangeCta;
    $[2] = headerSubtitle;
    $[3] = headerTitle;
    $[4] = phoneTexts;
  } else {
    emailChangeCta = $[1];
    headerSubtitle = $[2];
    headerTitle = $[3];
    phoneTexts = $[4];
  }
  let t1;
  if ($[5] !== onSubmit) {
    t1 = formData => {
      onSubmit(formData.phoneNumber);
    };
    $[5] = onSubmit;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleFormSubmit = t1;
  let t2;
  if ($[7] !== Header || $[8] !== headerSubtitle || $[9] !== headerTitle) {
    t2 = <Header title={headerTitle} subtitle={headerSubtitle} />;
    $[7] = Header;
    $[8] = headerSubtitle;
    $[9] = headerTitle;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== email || $[12] !== emailChangeCta || $[13] !== onChangeEmailClick) {
    t3 = email ? <EmailPreview email={email} onChange={onChangeEmailClick} textCta={emailChangeCta} /> : null;
    $[11] = email;
    $[12] = emailChangeCta;
    $[13] = onChangeEmailClick;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== defaultPhone || $[16] !== handleFormSubmit || $[17] !== isLoading || $[18] !== l10n || $[19] !== phoneTexts || $[20] !== phoneValidator) {
    t4 = <PhoneForm l10n={l10n} defaultPhone={defaultPhone} isLoading={isLoading} onSubmit={handleFormSubmit} texts={phoneTexts} validator={phoneValidator} />;
    $[15] = defaultPhone;
    $[16] = handleFormSubmit;
    $[17] = isLoading;
    $[18] = l10n;
    $[19] = phoneTexts;
    $[20] = phoneValidator;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== Footer || $[23] !== t2 || $[24] !== t3 || $[25] !== t4) {
    t5 = <div className="flex flex-col gap-8">{t2}{t3}{t4}{Footer}</div>;
    $[22] = Footer;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};
export default PhonePageStructure;